import styled from 'styled-components/macro';

import { border, colors, distances } from '../../styles/constants';

const Button = styled.button`
    padding: 10px ${distances.small};
    min-width: 138px;
    border-radius: 4px;
    color: ${colors.background};
    background: ${colors.primary};
    border: ${border.normal} solid ${colors.primary};
    text-decoration: none;
    user-select: none;
    font-weight: 700;
    font-size: 14px;
    line-height: ${distances.small};
    cursor: pointer;
    min-height: 40px;
    display: inline-block;
    text-align: center;

    &:hover {
        background: ${colors.primaryHover};
        border: ${border.normal} solid ${colors.primaryHover};
    }

    &:focus {
        outline: none;
    }

    &:disabled {
        background: ${colors.primaryDisabled};
        border-color: ${colors.primaryDisabled};
        cursor: not-allowed;
    }

    &.tiny {
        min-width: auto;
        padding: 0;
        height: ${distances.normal};
        padding-left: ${distances.tiny};
        padding-right: ${distances.tiny};
    }

    &.tiny-768 {
        @media (max-width: 768px) {
            min-width: auto;
            padding: 0;
            height: ${distances.normal};
            padding-left: ${distances.tiny};
            padding-right: ${distances.tiny};
        }
    }

    &.stretch {
        min-width: 100%;
    }

    &.stretch-768 {
        @media (max-width: 768px) {
            min-width: 100%;
        }
    }

    &.with-icon {
        padding-top: 3px;
        padding-bottom: 1px;
        padding-left: 1px;
    }

    &.alt {
        background: ${colors.background};
        color: ${colors.primary};
        border: ${border.normal} solid ${colors.borderLight};

        &:hover {
            border: ${border.normal} solid ${colors.primary};
        }
        &:focus {
            border: ${border.normal} solid ${colors.primaryFocusOutline};
        }
        &:active {
            background: ${colors.primary};
            color: ${colors.background};
        }
      
        &:disabled {
          opacity: .5;
          pointer-events: none;
        }
    }

    &.red {
        background: ${colors.invalid};
        border: ${border.normal} solid ${colors.invalid};

        &:hover {
            border: ${border.normal} solid ${colors.invalid};
        }
        &:active {
            border: ${border.normal} solid ${colors.invalid};
        }
    }
`;

export default Button;
